import React, { Fragment } from 'react'

import Script from 'dangerous-html/react'
import PropTypes from 'prop-types'
import './hero17.css'
import img1 from '../assets/1.jpg'
import img2 from '../assets/2.jpg'
// import img3 from '../assets/3.jpg'
import img4 from '../assets/4.jpg'
// import img5 from '../assets/5.jpg'
import img6 from '../assets/6.jpg'
import img7 from '../assets/7.jpg'
import img8 from '../assets/8.jpg'
import img9 from '../assets/9.jpg'
import img10 from '../assets/10.jpg'
import img11 from '../assets/11.jpg'
import img12 from '../assets/12.jpg'
import img13 from '../assets/13.jpg'
import img14 from '../assets/14.jpg'
import img15 from '../assets/15.jpg'
import img16 from '../assets/16.jpg'
import img17 from '../assets/17.jpg'
import img18 from '../assets/18.jpg'
import img19 from '../assets/19.jpg'
import img20 from '../assets/20.jpg'
import img21 from '../assets/21.jpg'
import img22 from '../assets/22.jpg'
import img23 from '../assets/23.jpg'
import img24 from '../assets/24.jpg'
import img25 from '../assets/25.jpg'
import img26 from '../assets/26.jpg'
import img27 from '../assets/27.jpg'
import img28 from '../assets/28.jpg'
import img29 from '../assets/29.jpg'
import static1 from '../assets/static1.jpg'
import static2 from '../assets/static2.jpg'

const Hero17 = (props) => {
  return (
    <div className={`hero17-header78 ${props.rootClassName} `}>
      <div className="hero17-column thq-section-padding thq-section-max-width">
        <div className="hero17-content1">
          <h1>
            {props.heading1 ?? (
              <Fragment>
                <h1 className="hero-text117 thq-heading-1">
                  Revolutionizing Pharma Marketing with Innovative Medicine
                  Marketing Solutions
                </h1>
              </Fragment>
            )}
          </h1>
          <p>
            {props.content1 ?? (
              <Fragment>
                <p className="hero-text116 thq-body-large">
                  E Lembos Life Sciences is dedicated to ensuring the safety and
                  integrity of pharmaceutical products through cutting-edge
                  medicine marketing solutions.
                </p>
              </Fragment>
            )}
          </p>
        </div>
        <div className="hero17-actions">
          <button className="thq-button-filled hero17-button1">
            <span>
              <a href='#step'>
                <Fragment>
                  <span className="hero17-text8 thq-body-small">
                    Checkout the steps
                  </span>
                </Fragment>
              </a>
            </span>
          </button>
          <button className="thq-button-outline hero17-button2">
            <span>
                <a href='#team'>
                <Fragment>
                  <span className="hero17-text6 thq-body-small">
                    Meet Our Team
                  </span>
                </Fragment>
                </a>
            </span>
          </button>
        </div>
      </div>
      <section id="product">
      <div className="hero17-content2">
        <div className="hero17-row-container1 thq-animated-group-container-horizontal thq-mask-image-horizontal">
          <div className="thq-animated-group-horizontal">
            <div className='image-container'><img
              alt={props.image1Alt}
              src={img1}
              className="hero17-placeholder-image10 thq-img-ratio-1-1 thq-img-scale"
            /></div>
            <div className='image-container'><img
              alt={props.image2Alt}
              src={img2}
              className="hero17-placeholder-image11 thq-img-ratio-1-1 thq-img-scale"
            /></div>
            <div className='image-container'><img
              alt={props.image4Alt}
              src={img4}
              className="hero17-placeholder-image13 thq-img-ratio-1-1 thq-img-scale"
            /></div>
            <div className='image-container'><img
              alt={props.image6Alt}
              src={img6}
              className="hero17-placeholder-image15 thq-img-ratio-1-1 thq-img-scale"
            /></div>
            <div className='image-container'><img
              alt={props.image6Alt1}
              src={img7}
              className="hero17-placeholder-image16 thq-img-ratio-1-1 thq-img-scale"
            /></div>
            <div className='image-container'><img
              alt={props.image6Alt11}
              src={img8}
              className="hero17-placeholder-image17 thq-img-ratio-1-1 thq-img-scale"
            /></div>
            <div className='image-container'><img
              alt={props.image6Alt115}
              src={img9}
              className="hero17-placeholder-image18 thq-img-ratio-1-1 thq-img-scale"
            /></div>
            <div className='image-container'><img
              alt={props.image6Alt114}
              src={img10}
              className="hero17-placeholder-image19 thq-img-ratio-1-1 thq-img-scale"
            /></div>
            <div className='image-container'><img
              alt={props.image6Alt113}
              src={img11}
              className="hero17-placeholder-image20 thq-img-ratio-1-1 thq-img-scale"
            /></div>
            <div className='image-container'><img
              alt={props.image6Alt112}
              src={img12}
              className="hero17-placeholder-image21 thq-img-ratio-1-1 thq-img-scale"
            /></div>
            <div className='image-container'><img
              alt={props.image6Alt111}
              src={img13}
              className="hero17-placeholder-image22 thq-img-ratio-1-1 thq-img-scale"
            /></div>
          </div>
          <div className="thq-animated-group-horizontal">
            <div className='image-container'><img
              alt={props.image1Alt}
              src={img1}
              className="hero17-placeholder-image23 thq-img-ratio-1-1 thq-img-scale"
            /></div>
            <div className='image-container'><img
              alt={props.image2Alt}
              src={img2}
              className="hero17-placeholder-image24 thq-img-ratio-1-1 thq-img-scale"
            /></div>
            <div className='image-container'><img
              alt={props.image4Alt}
              src={img4}
              className="hero17-placeholder-image26 thq-img-ratio-1-1 thq-img-scale"
            /></div>
            <div className='image-container'><img
              alt="Hero Image"
              src={img6}
              className="hero17-placeholder-image28 thq-img-ratio-1-1 thq-img-scale"
            /></div>
            <div className='image-container'><img
              alt="Hero Image"
              src={img7}
              className="hero17-placeholder-image29 thq-img-ratio-1-1 thq-img-scale"
            /></div>
            <div className='image-container'><img
              alt="Hero Image"
              src={img8}
              className="hero17-placeholder-image30 thq-img-ratio-1-1 thq-img-scale"
            /></div>
            <div className='image-container'><img
              alt="Hero Image"
              src={img9}
              className="hero17-placeholder-image31 thq-img-ratio-1-1 thq-img-scale"
            /></div>
            <div className='image-container'><img
              alt="Hero Image"
              src={img10}
              className="hero17-placeholder-image32 thq-img-ratio-1-1 thq-img-scale"
            /></div>
            <div className='image-container'><img
              alt="Hero Image"
              src={img11}
              className="hero17-placeholder-image32 thq-img-ratio-1-1 thq-img-scale"
            /></div>
          <div className='image-container'><img
              alt="Hero Image"
              src={img12}
              className="hero17-placeholder-image32 thq-img-ratio-1-1 thq-img-scale"
            /></div>
            <div className='image-container'><img
              alt="Hero Image"
              src={img13}
              className="hero17-placeholder-image32 thq-img-ratio-1-1 thq-img-scale"
            /></div>
          </div>
        </div>
        <div className="hero17-row-container2 thq-animated-group-container-horizontal thq-mask-image-horizontal">
          <div className="thq-animated-group-horizontal-reverse">
            <div className='image-container'><img
              alt={props.image7Alt}
              src={img14}
              className="hero17-placeholder-image33 thq-img-ratio-1-1 thq-img-scale"
            /></div>
            <div className='image-container'><img
              alt={props.image8Alt}
              src={img15}
              className="hero17-placeholder-image34 thq-img-ratio-1-1 thq-img-scale"
            /></div>
            <div className='image-container'><img
              alt={props.image9Alt}
              src={img16}
              className="hero17-placeholder-image35 thq-img-ratio-1-1 thq-img-scale"
            /></div>
            <div className='image-container'><img
              alt={props.image11Alt}
              src={img17}
              className="hero17-placeholder-image37 thq-img-ratio-1-1 thq-img-scale"
            /></div>
            <div className='image-container'><img
              alt={props.image12Alt4}
              src={img18}
              className="hero17-placeholder-image39 thq-img-ratio-1-1 thq-img-scale"
            /></div>
            <div className='image-container'><img
              alt={props.image12Alt4}
              src={img19}
              className="hero17-placeholder-image39 thq-img-ratio-1-1 thq-img-scale"
            /></div>
            <div className='image-container'><img
              alt={props.image12Alt4}
              src={img21}
              className="hero17-placeholder-image39 thq-img-ratio-1-1 thq-img-scale"
            /></div>
            <div className='image-container'><img
              alt={props.image12Alt3}
              src={img20}
              className="hero17-placeholder-image40 thq-img-ratio-1-1 thq-img-scale"
            /></div>
            <div className='image-container'><img
              alt={props.image12Alt1}
              src={img22}
              className="hero17-placeholder-image42 thq-img-ratio-1-1 thq-img-scale"
            /></div>
            <div className='image-container'><img
              alt={props.image10Alt}
              src={img23}
              className="hero17-placeholder-image36 thq-img-ratio-1-1 thq-img-scale"
            /></div>
            <div className='image-container'><img
              alt={props.image10Alt}
              src={img24}
              className="hero17-placeholder-image36 thq-img-ratio-1-1 thq-img-scale"
            /></div>
            <div className='image-container'><img
              alt={props.image10Alt}
              src={img25}
              className="hero17-placeholder-image36 thq-img-ratio-1-1 thq-img-scale"
            /></div>
            <div className='image-container'><img
              alt={props.image10Alt}
              src= {img26}
              className="hero17-placeholder-image36 thq-img-ratio-1-1 thq-img-scale"
            /></div>
            <div className='image-container'><img
              alt={props.image10Alt}
              src= {img28}
              className="hero17-placeholder-image36 thq-img-ratio-1-1 thq-img-scale"
            /></div>
            <div className='image-container'><img
              alt={props.image10Alt}
              src= {img29}
              className="hero17-placeholder-image36 thq-img-ratio-1-1 thq-img-scale"
            /></div>
          </div>
          <div className="thq-animated-group-horizontal-reverse">
          <div className='image-container'><img
              alt={props.image7Alt}
              src={img14}
              className="hero17-placeholder-image33 thq-img-ratio-1-1 thq-img-scale"
            /></div>
            <div className='image-container'><img
              alt={props.image8Alt}
              src={img15}
              className="hero17-placeholder-image34 thq-img-ratio-1-1 thq-img-scale"
            /></div>
            <div className='image-container'><img
              alt={props.image9Alt}
              src={img16}
              className="hero17-placeholder-image35 thq-img-ratio-1-1 thq-img-scale"
            /></div>
            <div className='image-container'><img
              alt={props.image11Alt}
              src={img17}
              className="hero17-placeholder-image37 thq-img-ratio-1-1 thq-img-scale"
            /></div>
            <div className='image-container'><img
              alt={props.image12Alt4}
              src={img18}
              className="hero17-placeholder-image39 thq-img-ratio-1-1 thq-img-scale"
            /></div>
            <div className='image-container'><img
              alt={props.image12Alt4}
              src={img19}
              className="hero17-placeholder-image39 thq-img-ratio-1-1 thq-img-scale"
            /></div>
            <div className='image-container'><img
              alt={props.image12Alt4}
              src={img21}
              className="hero17-placeholder-image39 thq-img-ratio-1-1 thq-img-scale"
            /></div>
            <div className='image-container'><img
              alt={props.image12Alt3}
              src={img20}
              className="hero17-placeholder-image40 thq-img-ratio-1-1 thq-img-scale"
            /></div>
            <div className='image-container'><img
              alt={props.image12Alt1}
              src={img22}
              className="hero17-placeholder-image42 thq-img-ratio-1-1 thq-img-scale"
            /></div>
            <div className='image-container'><img
              alt={props.image10Alt}
              src={img23}
              className="hero17-placeholder-image36 thq-img-ratio-1-1 thq-img-scale"
            /></div>
            <div className='image-container'><img
              alt={props.image10Alt}
              src={img24}
              className="hero17-placeholder-image36 thq-img-ratio-1-1 thq-img-scale"
            /></div>
            <div className='image-container'><img
              alt={props.image10Alt}
              src={img25}
              className="hero17-placeholder-image36 thq-img-ratio-1-1 thq-img-scale"
            /></div>
            <div className='image-container'>
              <img
                alt={props.image10Alt}
                src={img26}
                className="hero17-placeholder-image36 thq-img-ratio-1-1 thq-img-scale"
              />
            </div>
            <div className='image-container'>
              <img
                alt={props.image10Alt}
                src={img28}
                className="hero17-placeholder-image36 thq-img-ratio-1-1 thq-img-scale"
              />
            </div>
            <div className='image-container'>
              <img
                alt={props.image10Alt}
                src={img29}
                className="hero17-placeholder-image36 thq-img-ratio-1-1 thq-img-scale"
              />
            </div>
          </div>
        </div>
      </div>
      </section>
      <div className='static-product'>
      <img className='staticimg' src={static1} />
      <img className='staticimg' src={static2} />  
      </div>
      <div>
        <div className="hero17-container2">
          <Script
            html={`<style>
  @keyframes scroll-x {
    from {
      transform: translateX(0);
    }
    to {
      transform: translateX(calc(-100% - 16px));
    }
  }

  @keyframes scroll-y {
    from {
      transform: translateY(0);
    }
    to {
      transform: translateY(calc(-100% - 16px));
    }
  }
</style>
`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

Hero17.defaultProps = {
  image5Src:
    'https://images.unsplash.com/photo-1563762270340-3f5fde3243cd?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyOTQ3OTY4MXw&ixlib=rb-4.0.3&q=80&w=1080',
  image6Alt: 'Medicine Marketing Product 6',
  image7Src:
    'https://images.unsplash.com/photo-1573883431205-98b5f10aaedb?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyOTQ3OTY3OXw&ixlib=rb-4.0.3&q=80&w=1080',
  image4Src:
    'https://images.unsplash.com/photo-1664786908163-85ca46f85138?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyOTQ3OTY4MXw&ixlib=rb-4.0.3&q=80&w=1080',
  content1: undefined,
  action2: undefined,
  image11Src:
    'https://images.unsplash.com/photo-1559439055-2f33e9b91209?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyOTQ3OTY3OXw&ixlib=rb-4.0.3&q=80&w=1080',
  image10Src:
    'https://images.unsplash.com/photo-1607703703520-bb638e84caf2?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyOTQ3OTY4Mnw&ixlib=rb-4.0.3&q=80&w=1080',
  image9Alt: 'Medicine Marketing Product 9',
  image8Alt: 'Medicine Marketing Product 8',
  image7Alt: 'Medicine Marketing Product 7',
  image4Alt: 'Medicine Marketing Product 4',
  image5Alt: 'Medicine Marketing Product 5',
  heading1: undefined,
  image12Src:
    'https://images.unsplash.com/photo-1556679343-c7306c1976bc?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyOTQ3OTY4MHw&ixlib=rb-4.0.3&q=80&w=1080',
  image1Alt: 'Medicine Marketing Product 1',
  image9Src:
    'https://images.unsplash.com/photo-1587272114422-ec88be13ab1a?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyOTQ3OTY4MHw&ixlib=rb-4.0.3&q=80&w=1080',
  image3Src:
    'https://images.unsplash.com/photo-1543269865-cbf427effbad?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyOTQ3OTY3OHw&ixlib=rb-4.0.3&q=80&w=1080',
  image8Src:
    'https://images.unsplash.com/photo-1598481309151-970fbcc3c89d?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyOTQ3OTY4MHw&ixlib=rb-4.0.3&q=80&w=1080',
  image2Alt: 'Medicine Marketing Product 2',
  action1: undefined,
  image3Alt: 'Medicine Marketing Product 3',
  image2Src: '/img-20231207-wa0003-1500w.jpg',
  image12Alt: 'Medicine Marketing Product 12',
  image11Alt: 'Medicine Marketing Product 11',
  image1Src:
    'https://images.unsplash.com/photo-1620217310705-ea0af48e8158?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyOTQ3OTY4Mnw&ixlib=rb-4.0.3&q=80&w=1080',
  image10Alt: 'Medicine Marketing Product 10',
  rootClassName: '',
  image6Alt1: 'Medicine Marketing Product 6',
  image6Alt11: 'Medicine Marketing Product 6',
  image6Alt111: 'Medicine Marketing Product 6',
  image6Src111:
    'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyOTQ3OTY3OXw&ixlib=rb-4.0.3&q=80&w=1080',
  image6Alt112: 'Medicine Marketing Product 6',
  image6Alt113: 'Medicine Marketing Product 6',
  image6Alt114: 'Medicine Marketing Product 6',
  image6Alt115: 'Medicine Marketing Product 6',
  image12Src1:
    'https://images.unsplash.com/photo-1556679343-c7306c1976bc?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyOTQ3OTY4MHw&ixlib=rb-4.0.3&q=80&w=1080',
  image12Alt1: 'Medicine Marketing Product 12',
  image12Src2:
    'https://images.unsplash.com/photo-1556679343-c7306c1976bc?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyOTQ3OTY4MHw&ixlib=rb-4.0.3&q=80&w=1080',
  image12Alt2: 'Medicine Marketing Product 12',
  image12Src3:
    'https://images.unsplash.com/photo-1556679343-c7306c1976bc?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyOTQ3OTY4MHw&ixlib=rb-4.0.3&q=80&w=1080',
  image12Alt3: 'Medicine Marketing Product 12',
  image12Src4:
    'https://images.unsplash.com/photo-1556679343-c7306c1976bc?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyOTQ3OTY4MHw&ixlib=rb-4.0.3&q=80&w=1080',
  image12Alt4: 'Medicine Marketing Product 12',
}

Hero17.propTypes = {
  image5Src: PropTypes.string,
  image6Alt: PropTypes.string,
  image7Src: PropTypes.string,
  image4Src: PropTypes.string,
  content1: PropTypes.element,
  action2: PropTypes.element,
  image11Src: PropTypes.string,
  image10Src: PropTypes.string,
  image9Alt: PropTypes.string,
  image8Alt: PropTypes.string,
  image7Alt: PropTypes.string,
  image4Alt: PropTypes.string,
  image5Alt: PropTypes.string,
  heading1: PropTypes.element,
  image12Src: PropTypes.string,
  image1Alt: PropTypes.string,
  image9Src: PropTypes.string,
  image3Src: PropTypes.string,
  image8Src: PropTypes.string,
  image2Alt: PropTypes.string,
  action1: PropTypes.element,
  image3Alt: PropTypes.string,
  image2Src: PropTypes.string,
  image12Alt: PropTypes.string,
  image11Alt: PropTypes.string,
  image1Src: PropTypes.string,
  image10Alt: PropTypes.string,
  rootClassName: PropTypes.string,
  image6Alt1: PropTypes.string,
  image6Alt11: PropTypes.string,
  image6Alt111: PropTypes.string,
  image6Src111: PropTypes.string,
  image6Alt112: PropTypes.string,
  image6Alt113: PropTypes.string,
  image6Alt114: PropTypes.string,
  image6Alt115: PropTypes.string,
  image12Src1: PropTypes.string,
  image12Alt1: PropTypes.string,
  image12Src2: PropTypes.string,
  image12Alt2: PropTypes.string,
  image12Src3: PropTypes.string,
  image12Alt3: PropTypes.string,
  image12Src4: PropTypes.string,
  image12Alt4: PropTypes.string,
}

export default Hero17
